import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router';
import { useAuth } from '@/context/useAuth';
import CustomSpinner from '@/components/Common/CustomSpinner';

const InitialPassGuard = () => {
  const navigate = useNavigate();
  const { isInitial, loading } = useAuth();

  useEffect(() => {
    // Only redirect if inisial reset is true
    if (!loading && isInitial) {
      console.log(
        'User has initial password, redirecting to password reset page',
      );
      navigate('/set_init_pass', { replace: true });
    }
  }, [isInitial, loading, navigate]);

  if (loading) {
    return <CustomSpinner height="100vh" />;
  }

  return <Outlet />;
};

export default InitialPassGuard;
